import React, { useEffect, useState } from 'react';
import { Stack, Typography, Box, Card, CardMedia, IconButton } from '@mui/material';

import { request } from '../../../Utils/request';
import { Share as ShareIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { paiseToRupees } from '../../../Utils/currencyConverter';
import { useSelector } from 'react-redux';



/**
 * Displays a simple list of reservations made by the user.
 * Currently it renders all trips that are passed in. If a dedicated
 * reservation status is available from the API you can pre-filter the
 *   array before passing it to this component.
 */
const ReservationsTab: React.FC = () => {
  const [myReservations, setMyReservations] = useState<any[]>([]);
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
  useEffect(() => {
    const fetchMyReservations = async () => {
      const res = await request<{ data: any }>('/bookings/me?filter=upcoming', {
        method: 'GET',
        authorization: true,
      });
      console.log("myReservations", res);
      setMyReservations(res?.data);
    }
    if(isLoggedIn)
    fetchMyReservations();
  }, []);
  if(myReservations.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          No Reservations found
        </Typography>
      </Box>
    )
  }
  return (
    <Box sx={{}}>
      <Stack spacing={2}>
        {  myReservations.map((reservation) => (
            <Card
              sx={{
                borderRadius: 3,
                boxShadow: 1,
                mb: 2,
                overflow: 'hidden',
                position: 'relative',
                cursor: 'pointer',
                '&:hover': {
                  boxShadow: 2,
                },
              }}
              onClick={() => {
                navigate(`/trip/bookinginfo`, { 
                  state: { bookingData: reservation } 
                });
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
                <CardMedia
                  component="img"
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: 2,
                    mr: 2,
                    objectFit: 'cover'
                  }}
                  image={reservation.files?.[0]?.fileURL }
                  alt={reservation.title || reservation.name}
                />
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 0.5 }}>
                    {reservation.title || reservation.name || reservation.destination}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                    {reservation.days || reservation.duration || '3'} Days • ₹{paiseToRupees(reservation.pricePerPerson || reservation.price ).toFixed(2)}/person
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    <Box
                      onClick={() => {
                        navigate(`/profile/${reservation.user?._id}`);
                      }}
                      sx={{
                        background: 'linear-gradient(90deg, #FF9800 0%, #FF5722 100%)',
                        color: '#fff',
                        borderRadius: 2,
                        px: 2,
                        py: 0.5,
                        fontSize: '12px',
                        fontWeight: 500,
                        minWidth: 'fit-content',
                      }}
                    >
                      {reservation.user?.username}
                    </Box>
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        // onShare?.(reservation.trip);
                      }}
                      sx={{
                        border: '1px solid #e0e0e0',
                        borderRadius: 2,
                        width: 36,
                        height: 36,
                        ml: 'auto',
                      }}
                    >
                      <ShareIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  background: 'linear-gradient(90deg, #FF9800 0%, #FF5722 100%)',
                  color: '#fff',
                  borderRadius: '0 0 0 16px',
                  px: 2,
                  py: 0.5,
                  fontSize: '12px',
                  fontWeight: 500,
                  boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                }}
              >
                {reservation.type}
              </Box>
            </Card>
          ))
        }
      </Stack>
    </Box>
  );
};

export default ReservationsTab;
